module.exports = __webpack_public_path__ + "img/create.6cae8d11.png";